import React from 'react';
import Grid from '@mui/material/Grid2';

import { StringListEnhancement } from "@dndModels";

import SelectObjectBox from '@components/input/selects/SelectObjectBox';
import EnhancementModeBox from './EnhancementModeBox';

interface Props {
  value: StringListEnhancement;
  disabled: boolean;
  onChange: () => void;
}

// Same "mode + list" shape would work for `tags` too, if you bring that back later.
export default function GiftIdsEnhancementInput({
  value,
  disabled,
  onChange
}: Props) {
  return (
    <Grid container spacing={0} direction="row">
      <Grid size={4}>
        <EnhancementModeBox
          name="Gifts Mode"
          modes={["Leave","Replace","Add"]}
          value={value.mode}
          disabled={disabled}
          onChange={(changed) => {
            value.mode = changed as StringListEnhancement["mode"];
            onChange();
          }}
        />
      </Grid>
      <Grid size={8}>
        <SelectObjectBox
          name="Gifts to Automatically Apply"
          data_type="creature_gift"
          values={value.value}
          disabled={disabled || value.mode === "Leave"}
          multiple
          display_format='{obj.use_name}'
          onChange={(changed: string[]) => {
            value.value = changed;
            onChange();
          }}
        />
      </Grid>
    </Grid>
  );
}
